/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Processing_TimeoutInputs */

const cs_documents_processing_timeout = /** @type {(inputs: Documents_Processing_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument se ještě zpracovává — obnovte stránku za chvíli.`)
};

const en_documents_processing_timeout = /** @type {(inputs: Documents_Processing_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document is still processing — refresh in a moment.`)
};

/**
* | output |
* | --- |
* | "Document is still processing — refresh in a moment." |
*
* @param {Documents_Processing_TimeoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_processing_timeout = /** @type {((inputs?: Documents_Processing_TimeoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Processing_TimeoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_processing_timeout(inputs)
	return cs_documents_processing_timeout(inputs)
});